import { render } from "./imgfinal_ingles.vue?vue&type=template&id=1cfc5b54&scoped=true"
import script from "./imgfinal_ingles.vue?vue&type=script&lang=js"
export * from "./imgfinal_ingles.vue?vue&type=script&lang=js"

import "./imgfinal_ingles.vue?vue&type=style&index=0&id=1cfc5b54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfc5b54"]])

export default __exports__